<template>
  <div class="testv__member__card__wrapper">
    <div class="testv__benefit__card__bg">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" class="corner">
        <path d="M0,4c0-2.2091,0-4,0-4h100v100H59.6467c-1.0548,0-2.067-0.417-2.8161-1.159L1.1838,43.674
          C0.4262,42.923,0,41.9,0,40.833V4z"/>
      </svg>
    </div>
    <div class="testv__member__card">
      <div class="testv__member__card__name">{{ '铁丝\n会籍' }}</div>
      <div class="testv__member__card__logo"><IconLogoTestv/></div>
      <div class="testv__member__card__date">
        <span class="label">会员服务期</span>
        <span class="value">{{ expiredAt }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from '@/utils/index.js'

export default {
  name: 'TestvMemberCard',

  props: {
    expiredAt: String
  },

  filters: {
    formatDate
  }
}
</script>

<style lang="stylus" scoped>
@import "~@/assets/styles/variable.styl"
.testv__member__card__wrapper {
  position: relative;
}
.testv__member__card {
  position: relative;
  width: 100%;
  height: 274px;
  color: var(--dark-bwb-0);
  font-size: 0;
  .testv__member__card__name,
  .testv__member__card__logo,
  .testv__member__card__date {
    position: absolute;
  }
  .testv__member__card__name {
    white-space: pre-wrap;
    font-size: 32px;
    font-weight: 600;
    top: 24px;
    left: 24px;
    @media (min-width: $screen-md) {
      font-size: 40px;
    }
  }
  .testv__member__card__logo {
    width: 234px;
    height: 35px;
    top: 50%;
    right: 40px;
    transform: translate(50%, -50%) rotate(90deg);
    svg {
      width: 100%;
      height: 100%;
    }
  }
  .testv__member__card__date {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 124px;
    height: 124px;
    bottom: 0;
    left: 0;
    transform: rotate(45deg);
    white-space: nowrap;
    .label {
      font-size: 13px;
      font-weight: 500;
    }
    .value {
      font-size: 15px;
      font-family: ui-monospace, 'SF Mono', monospace;
      font-weight: 500;
    }
    .text {
      font-size: 12px;
    }
  }
}

.testv__benefit__card__bg {
  color: var(--yellow-testv);
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 0;
  .corner {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100px;
    height: 100px;
  }
  &::before {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    top: 0;
    bottom: 100px;
    background: var(--yellow-testv);
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
  &::after {
    content: '';
    display: block;
    position: absolute;
    left: 100px;
    right: 0;
    bottom: 0;
    height: 100px;
    background: var(--yellow-testv);
    border-bottom-right-radius: 4px;
  }
}
</style>
